export var KEEP_CHANGES = "keep_changes";
export var DISCARD_CHANGES = "discard_changes";